export default {
    'types': {
        currentlyReading: {
            id: "currentlyReading",
            label: "Currently Reading",
            color: '#8887d1',
            isShelf: true,
            isOption: true
        },
        wantToRead: {
            id: "wantToRead",
            label: "Want to Read",
            color: '#d187cb',
            isShelf: true,
            isOption: true
        },
        read: {
            id: "read",
            label: "Read",
            color: '#8fd187',
            isShelf: true,
            isOption: true
        },
        none: {
            id: "none",
            label: "None",
            color: '',
            isShelf: false,
            isOption: true
        }
    }
}


// WEBPACK FOOTER //
// ./src/config/shelvesConfig.js